import { render, staticRenderFns } from "./VitaminaD.vue?vue&type=template&id=536779bc&scoped=true&"
import script from "./VitaminaD.vue?vue&type=script&lang=js&"
export * from "./VitaminaD.vue?vue&type=script&lang=js&"
import style0 from "./VitaminaD.vue?vue&type=style&index=0&id=536779bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536779bc",
  null
  
)

export default component.exports